import { render, staticRenderFns } from "./promotion-list.vue?vue&type=template&id=a78b468c"
import script from "./promotion-list.vue?vue&type=script&lang=js"
export * from "./promotion-list.vue?vue&type=script&lang=js"
import style0 from "./promotion-list.vue?vue&type=style&index=0&id=a78b468c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3284107251/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a78b468c')) {
      api.createRecord('a78b468c', component.options)
    } else {
      api.reload('a78b468c', component.options)
    }
    module.hot.accept("./promotion-list.vue?vue&type=template&id=a78b468c", function () {
      api.rerender('a78b468c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/promotion-list.vue"
export default component.exports